<template>
  <div id="container">
    <div class="content">
      <div class="product-status">
        <div class="bold"></div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane
            :label="item.title"
            :name="item.name"
            class="tab-text"
            v-for="item in productStatusList"
            :key="item.name"
          ></el-tab-pane>
        </el-tabs>
        <!------------ 搜索 ------------>
        <search
          @getList="getList"
          @addProduct="addproduct"
          v-if="productStatusList"
          @searchFor="searchFor"
          @changeName='changeName'
          @searchForReset="searchForReset"
          :activeName="activeName"
          :pitchOnList="pitchOnList"
          :searchReform.sync="searchReform"
        ></search>
        <!-------------- 上线列表,下线列表,临时产品列表 ------------>
        <product-table
          :online="tableData"
          :activeName="activeName"
          :loadingTable="loadingTable"
          @checkList="getCheckList"
        ></product-table>
        <!-------------- 分页 -------------->
        <div class="pagination">
          <pagination
            :total="total"
            :currentPage="currentPage"
            :pageSize="pageSize"
            @handleCurrentChange="handleCurrentChange"
            @handleSizeChange="handleSizeChange"
          ></pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import search from '../components/productStatus/search'
import productTable from '../components/productStatus/productTable'
import pagination from '@/components/pagination'
import { productBaseQueryPageAll } from '@/api/product/productManage'
import { productStatusList } from '../utils/data'
export default {
  components: {
    search,
    productTable,
    pagination
  },
  data () {
    return {
      searchReform: {},
      currentPage: 1,
      pageSize: 30,
      productStatusList: [],
      activeName: 'online',
      tableData: [], // 表格数据
      total: 0,
      queryParamsList: {},
      queryParams: {},
      loadingTable: false,
      state: 0,
      pitchOnList: [] // 列表选中的数据
    }
  },
  mounted () {
    this.activeName = this.$route.query.goTo || 'online'
    // 详情保存跳转
    // if (this.$route.params.goTo === 'temporaryProduct') {
    //   this.activeName = 'temporaryProduct'
    // } else if (this.$route.params.goTo === 'online') {
    //   this.activeName = 'online'
    // } else if (this.$route.params.goTo === 'offline') {
    //   this.activeName = 'offline'
    // }
    this.queryProductTable()
    this.height = document.documentElement.clientHeight
    this.productStatusList = productStatusList
  },

  methods: {
    getList () {
      this.queryProductTable()
      this.height = document.documentElement.clientHeight
      this.productStatusList = productStatusList
    },
    handleClick (tab) {
      this.currentPage = 1
      this.pageSize = 30
      this.activeName = tab.name
      this.queryProductTable()
    },
    // 初始化产品表格
    queryProductTable () {
      this.loadingTable = true
      if (this.activeName === 'online') {
        // 上线列表
        this.state = 1
      } else if (this.activeName === 'offline') {
        // 下线列表
        this.state = 0
      } else if (this.activeName === 'temporaryProduct') {
        // 临时产品列表
        this.state = 2
      }
      const queryParams = JSON.parse(JSON.stringify(this.queryParamsList))
      if (JSON.stringify(queryParams) !== '{}') {
        if (queryParams.brandIds === undefined) {
          queryParams.brandIds = []
        }
        if (queryParams.seriesIds === undefined) {
          queryParams.seriesIds = []
        }
        if (queryParams.brandIds.length === 0) {
          delete queryParams.brandIds
        } else {
          queryParams.brandIds = queryParams.brandIds.toString()
        }
        if (queryParams.seriesIds.length === 0) {
          delete queryParams.seriesIds
        } else {
          queryParams.seriesIds = queryParams.seriesIds.toString()
        }
      }

      const params = {
        criteriaVoList: this.$queryParams(queryParams, 'moreSearch'),
        queryPageName: ''
      }
      productBaseQueryPageAll(this.state, this.currentPage, this.pageSize, params)
        .then((res) => {
          if (res.data.code === 200) {
            this.loadingTable = false
            this.tableData = res.data.obj.records
            this.total = res.data.obj.total
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取选中列表中的数据
    getCheckList (list) {
      this.pitchOnList = list
    },
    // 添加产品
    addproduct () {
      this.$router.push({
        name: 'addProduct',
        query: {
          name: this.activeName
        }
      })
    },
    // 页数
    handleSizeChange (val) {
      this.pageSize = val
      this.queryProductTable()
    },
    // 页码
    handleCurrentChange (val) {
      this.currentPage = val
      this.queryProductTable()
    },
    searchForReset () {
      this.currentPage = 1
      this.pageSize = 30
      this.queryProductTable()
    },
    changeName(name) {
      this.activeName = name
      this.queryProductTable()
    },
    // 搜索
    searchFor (params) {
      this.queryParamsList = JSON.parse(JSON.stringify(params))
      if (this.queryParamsList.productClassId !== undefined) {
        this.queryParamsList.productClassId =
          this.queryParamsList.productClassId[this.queryParamsList.productClassId.length - 1]
      }
      this.currentPage = 1
      this.pageSize = 30
      this.queryProductTable()
    }
  }
}
</script>
